import StoreDecorator, {
  Action,
  Mutation,
  Getter,
  AutoLoading,
} from '@acgn/herm/lib/store-decorator';

import {
  login,
  scanLogin,
  logout,
  isLogin,
  changeUserDept,
} from '../../api/auth';
import { LoginUtil } from '@acgn/herm/src/util';
interface StateType {
  userInfo: any; // 用户基础信息
}
@StoreDecorator
@AutoLoading
class StoreModule {
  public state(): StateType {
    return {
      userInfo: {},
    };
  }

  // 登录
  @Action('setUserInfo')
  public async login(state: StateType, payload: any) {
    return await login(payload);
  }

  // 扫码登录
  @Action('setUserInfo')
  public async scanLogin(state: StateType, payload: any) {
    return await scanLogin(payload);
  }

  // 选择或切换用户所在的二级部门
  @Action()
  public async changeUserDept(state: StateType, payload: any) {
    return await changeUserDept(payload);
  }

  // 登出
  @Action()
  public async logout(state: StateType, payload: any) {
    return await logout(payload);
  }

  public isAuth(routesMap: any) {
    const pathname = window.location.pathname;
    const route = routesMap[pathname.replace(/\/$/, '')] || {};
    if (route.isauth === false) {
      return false;
    }
    return true;
  }

  // 获取用户信息（权限）,如果没有，则进行获取，并保存
  @Action()
  public async getUserPermissions({
    commit,
    state,
    rootGetters,
    rootState,
  }: any) {
    if (
      Object.keys(state.userInfo).length > 0 ||
      !this.isAuth(rootState.apps.routesMap)
    ) {
      return;
    }

    if (LoginUtil.gettingUserInfoPromise) {
      // 如果在获取用户信息中了，则等待获取
      await LoginUtil.gettingUserInfoPromise;
      return;
    }

    LoginUtil.makePendingGettingUserInfoPromise();
    try {
      const result = await isLogin(null);
      commit('setUserInfo', result);

      LoginUtil.resolveGettingUserInfoPromise();
      LoginUtil.clearPendingGettingUserInfoPromise();
      // 如果是在登录页，且登录了，直接转首页
      LoginUtil.redirectLogin(true);
    } catch (ex) {
      LoginUtil.clearPendingGettingUserInfoPromise();
      // 获取信息失败，跳到登录页
      LoginUtil.redirectLogin(false);
    }
  }

  // 刷新用户信息
  @Action()
  public async refreshUserInfo({ commit, state }: any) {
    if (LoginUtil.gettingUserInfoPromise) {
      // 如果在获取用户信息中了，则等待获取
      await LoginUtil.gettingUserInfoPromise;
      return;
    }

    LoginUtil.makePendingGettingUserInfoPromise();
    try {
      const result = await isLogin(null);
      commit('setUserInfo', result);

      LoginUtil.resolveGettingUserInfoPromise();
      LoginUtil.clearPendingGettingUserInfoPromise();
      // 如果是在登录页，且登录了，直接转首页
      LoginUtil.redirectLogin(true);
    } catch (ex) {
      LoginUtil.clearPendingGettingUserInfoPromise();
      // 获取信息失败，跳到登录页
      LoginUtil.redirectLogin(false);
    }
  }

  // 设置用户基础信息
  @Mutation('userInfo')
  public setUserInfo(state: StateType, payload: any) {
    return payload.result;
  }

  // 设置用户部门信息
  @Mutation()
  public setUserDepartInfo(state: StateType, payload: any) {
    state.userInfo.now_dept = payload;
  }

  // 获取用户基础信息
  @Getter
  public userInfo(state: StateType) {
    return state.userInfo;
  }

  @Getter
  public permissions(state: StateType) {
    if (!state.userInfo) {
      return [];
    }
    return state.userInfo.permissions;
  }
}

export default new StoreModule();
